import {combineReducers} from 'redux';

import AuthReducer from './AuthReducer';
import ManageUserReducer from './ManageUserReducer';
import AgencyProfileReducer from './AgencyProfileReducer';
import AgencyLocationSaveReducer from './AgencyLocationReducer';
import ManageUserDetailReducer from './ManageUserDetailReducer';
import LocationReducer from './LocationReducer';
import AgencyProfileSaveReducer from './AgencyProfileUpdateReducer'
import AgencyLocationReducer from './AgencyLocation';
import AgencyRevenueReducer from './AgencyRevenueReducer';
import LocationListReducer from './LocationListReducer';
import DefaultAgencyProfileReducer from "./DefaultAgencyProfileReducer";
import PiChartReducer from "./PiChartReducer";
import PlListReducer from "./PlListReducer";
import RevenueProfileReducer from "./RevenueProfileReducer";
import RevenueGoalReducer from "./RevenueGoalReducer";
import OverrideRevenueGoalReducer from "./OverrideRevenueGoalReducer";
import LineGraphReducer from "./LineGraphReducer"
import PLCategoryReducer from "./PLCategoryReducer";
import PLWorksheetReducer from "./PLWorksheetReducer";
import OperativeItemReducer from "./OperativeItemReducer";
import PayrollItemReducer from "./PayrollItemReducer";
import PlannedItemReducer from "./PlannedItemReducer";
import MarketingItemReducer from "./MarketingItemReducer";
import CapitalItemReducer from "./CapitalItemReducer";
import JobDescriptionReducer from "./JobDescriptionReducer";
import JobTitleReducer from "./JobTitleReducer";
import AllKPICategoryReducer from "./AllKPICategoryReducer";
import CompensationReducer from "./CompensationProfileReducer";
import KPIHeadingItemListReducer from "./KPIHeadingItemListReducer";
import KPIHeadingListReducer from "./KPIHeadingListReducer";
import DailyAttendanceReducer from "./DailyAttendanceReducer";
import StaffDashboardReducer from "./StaffDashboardReducer";
import StaffDataReducer from "./StaffDataReducer";
import PeerEvaluationReducer from "./PeerEvaluationReducer";
import OrganicGrowthWizardReducer from "./OrganicGrowthWizardReducer";
import ReportReducer from "./ReportReducer";
import ComplianceAuditReducer from "./ComplianceAuditReducer";
import SaveStateReducer from "./SaveStateReducer";
import IWReducer from "./InstallationWizardReducer";
import KPIPlanningReducer from "./KPIPlanningReducer";
import AgencyMonitorReducer from "./AgencyMonitorReducer";
import KPIReducer from "./KpiReducer";
import KBReducer from "./KBReducer";
import PTOReducer from "./PTOReducer";
import ProducerReducer from "./ProducerReducer";


export default combineReducers({
    AuthReducer,
    ManageUserReducer,
    AgencyProfileReducer,
    ManageUserDetailReducer,
    LocationReducer,
    AgencyProfileSaveReducer,
    AgencyLocationSaveReducer,
    AgencyLocationReducer,
    AgencyRevenueReducer,
    LocationListReducer,
    DefaultAgencyProfileReducer,
    PiChartReducer,
    PlListReducer,
    RevenueProfileReducer,
    RevenueGoalReducer,
    OverrideRevenueGoalReducer,
    LineGraphReducer,
    PLCategoryReducer,
    PLWorksheetReducer,
    OperativeItemReducer,
    PayrollItemReducer,
    CapitalItemReducer,
    MarketingItemReducer,
    PlannedItemReducer,
    JobTitleReducer,
    JobDescriptionReducer,
    AllKPICategoryReducer,
    CompensationReducer,
    KPIHeadingItemListReducer,
    KPIHeadingListReducer,
    DailyAttendanceReducer,
    StaffDashboardReducer,
    PeerEvaluationReducer,
    StaffDataReducer,
    OrganicGrowthWizardReducer,
    ReportReducer,
    ComplianceAuditReducer,
    SaveStateReducer,
    IWReducer,
    KPIPlanningReducer,
    AgencyMonitorReducer,
    KPIReducer,
    KBReducer,
    PTOReducer,
    ProducerReducer,
})




// WEBPACK FOOTER //
// ./src/reducers/index.js